
import gtSidebar from '@/components/billing/sidebar/gt-sidebar.vue';

export default {
	name: 'billing-home',
	mixins: [],
	extends: {},
	components: { gtSidebar },
	props: [],
	data() {
		return {
			
		};
	},
	computed: {
		
	},
	watch: {},
	created() {
	},
	mounted() {
		
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		
	},
};



// WEBPACK FOOTER //
// ./src/components/home.js